module.exports = __webpack_public_path__ + "img/astig_logo.b6034f89.png";